module.exports = __webpack_public_path__ + "src/assets/images/cam_icon.png?fcd5af089c62fbf9df49b405dae4f2a4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cam_icon.png
// module id = 984
// module chunks = 1